import { NgModule } from '@angular/core';

import { BaseModule } from '@shared';
import { LayoutComponent } from './layout.component';
import { ConceptSelectorComponent, TermsOfServiceComponent, TierSelectorComponent } from './components';
import { SharedDataModule } from '@shared-data';
import { RestaurantItemModule } from '@restaurant-item';

@NgModule({
  declarations: [
    LayoutComponent,
    TierSelectorComponent,
    TermsOfServiceComponent,
    ConceptSelectorComponent,
  ],
  imports: [BaseModule, SharedDataModule, RestaurantItemModule],
  exports: [LayoutComponent],
  providers: [],
})
export class LayoutModule {}
